import React, { useState, useEffect } from "react";
import SummaryApi from "../../common";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import ModalProfessor from "./ModalProfessor"; // Import the ModalProfessor component

const AllProfessor = () => {
  const [professors, setProfessors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editProfessor, setEditProfessor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // Manage modal state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const professorResponse = await fetch(SummaryApi.getAllProfessors.url);
        const professorResult = await professorResponse.json();

        if (professorResult.status) {
          setProfessors(professorResult.data);
        } else {
          throw new Error("Failed to fetch professor data");
        }

        const departmentResponse = await fetch(SummaryApi.getAllDepartment.url);
        const departmentResult = await departmentResponse.json();

        if (departmentResult.status) {
          setDepartments(departmentResult.data);
        } else {
          throw new Error("Failed to fetch department data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading professors...</div>;
  if (error) return <div>Error: {error}</div>;

  // Open the modal to edit professor data
  const handleEdit = (professor) => {
    setEditProfessor(professor);
    setIsModalOpen(true); // Open modal
  };
  const handleSave = (updatedProfessor) => {
    setProfessors((prevProfessors) =>
      prevProfessors.map((professor) =>
        professor.professor_id === updatedProfessor.professor_id
          ? updatedProfessor
          : professor
      )
    );
    handleCloseModal();
  };
  // Close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditProfessor(null); // Reset the professor data when the modal is closed
  };

  const getDepartmentName = (deptId) => {
    const department = departments.find(
      (dept) => dept.department_id === deptId
    );
    return department ? department.department_name : "Department Not Found";
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-3">All Professors</h1>
      <nav className="text-gray-600 mb-4">
        <ol className="flex space-x-2 text-[16px]">
          <li>
            <Link to="/" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="allProfessor" className="hover:text-[#ffa404]">
              All Professors
            </Link>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {professors.length === 0 ? (
          <p className="text-center text-xl text-gray-500">
            No professors found
          </p>
        ) : (
          professors.map((professor) => (
            <div
              key={professor.professor_id}
              className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center space-x-6">
                <img
                  src={`${
                    SummaryApi.getProfessorImage.url
                  }${professor.professor_image.split("/").pop()}`}
                  alt={`${professor.first_name} ${professor.last_name}`}
                  className="w-24 h-24 rounded-full object-cover  "
                />
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-gray-800">
                    {professor.first_name} {professor.last_name}
                  </h3>
                  <h4 className="text-sm text-gray-500">
                    <strong>Department:</strong>{" "}
                    {getDepartmentName(professor.department_id)}
                  </h4>
                </div>
              </div>

              <div className="mt-4 text-sm text-gray-700 space-y-2">
                <p>
                  <strong>Email:</strong> {professor.email}
                </p>
                <p>
                  <strong>Degree:</strong> {professor.degree}
                </p>
                <p>
                  <strong>Specialization:</strong> {professor.specialization}
                </p>
                <p>
                  <strong>Office Room:</strong> {professor.office_room}
                </p>
                <p>
                  <strong>Salary:</strong> {professor.salary}
                </p>
                <p>
                  <strong>Office Hours:</strong> {professor.office_hours}
                </p>
                <p>
                  <strong>Status:</strong> {professor.status}
                </p>
                <p>
                  <strong>Hired Date:</strong> {professor.hire_date}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {professor.mobile_number}
                </p>
              </div>

              <div className="flex justify-between mt-2">
                <button
                  onClick={() => handleEdit(professor)}
                  className="bg-white text-orange-500 border-2 border-orange-500 px-5 py-3 rounded-md transition-all duration-1000 ease-in-out hover:bg-gradient-to-r hover:from-orange-300 hover:via-orange-500 hover:to-orange-700 hover:text-white font-bold"
                >
                  Edit
                </button>
                <p
                  className={`mt-2 p-2 rounded-md text-center ${
                    professor.is_active === "1"
                      ? "bg-green-500 text-white"
                      : "bg-red-500 text-white"
                  }`}
                >
                  {professor.is_active ? "Active" : "Inactive"}
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Render the Modal when it's open */}
      {/* {isModalOpen && (
        <ModalProfessor professor={editProfessor} onClose={handleCloseModal} />
      )} */}
      {isModalOpen && (
        <ModalProfessor
          professor={editProfessor}
          onClose={handleCloseModal}
          onSave={handleSave}
          departments={departments} // Pass departments here
        />
      )}
    </div>
  );
};

export default AllProfessor;
